import { GetDocumentListTktResponse } from 'src/sdk-servicing';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { GetDocumentListTktResultModel } from './get-document-list-tkt-result.state';

/** StateDetailsActions */
const ACTION_SET = '[GetDocumentListTktResult] set';
const ACTION_UPDATE = '[GetDocumentListTktResult] update';
const ACTION_RESET = '[GetDocumentListTktResult] reset';
const ACTION_FAIL = '[GetDocumentListTktResult] fail';
const ACTION_CANCEL_REQUEST = '[GetDocumentListTktResult] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[GetDocumentListTktResult] set from api';
const ACTION_UPDATE_FROM_API = '[GetDocumentListTktResult] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setGetDocumentListTktResult = createAction(
  ACTION_SET,
  props<WithRequestId<GetDocumentListTktResultModel>>()
);

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateGetDocumentListTktResult = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<GetDocumentListTktResultModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetGetDocumentListTktResult = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelGetDocumentListTktResultRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failGetDocumentListTktResult = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setGetDocumentListTktResultFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<GetDocumentListTktResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateGetDocumentListTktResultFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<GetDocumentListTktResponse>>()
);
